import {ref} from 'vue';
import {IDrawZone} from '@/app/shared/components/kl-draw-zone-map/components/kl-draw-zone-sidebar/kl-draw-zone-sidebar';
import {cloneDeep, filter, first, size} from 'lodash-es';
import KlDrawZoneMapUtils from '@/app/shared/components/kl-draw-zone-map/kl-draw-zone-map-utils';
import Feature from 'ol/Feature';

export interface IZoneContextOptions {
    maprequestReference: string;
}

export function useDrawZoneZoneContext(options: IZoneContextOptions) {

    const _maprequestReference = ref<string>(options.maprequestReference);

    const zones = ref<IDrawZone[]>(null);
    const _zonesBackup = ref<IDrawZone[]>(null);

    const currentZone = ref<IDrawZone>(null);

    const _manualZoneNames = ref<{ [id: number]: string }>({});
    const _manualZoneNamesBackup = ref<{ [id: number]: string }>({});

    const init = () => {
        _manualZoneNames.value = {};
    }

    const updateMaprequestReference = (ref: string) => {
        _maprequestReference.value = ref;

        KlDrawZoneMapUtils.updateZoneNames(zones.value, ref, _manualZoneNames.value);
    }

    const clearAll = () => {
        // zones.value?.forEach((cz: IDrawZone) => {
        //     removeZone(cz)
        // });
        setCurrentZone(null);

        zones.value = [];
        _zonesBackup.value = [];
        _manualZoneNames.value = {};
        _manualZoneNamesBackup.value = {};
    }

    const removeZone = (drawZone: IDrawZone) => {
        zones.value = filter(zones.value, (cz: IDrawZone) => cz.id !== drawZone.id);
        KlDrawZoneMapUtils.updateZoneNames(zones.value, _maprequestReference.value, _manualZoneNames.value);

        if (currentZone.value?.id === drawZone.id) {
            setCurrentZone(null);
        }
    }

    const setCurrentZone = (zone: IDrawZone) => {
        currentZone.value = zone;
    }

    const revertCurrentZone = () => {
        console.assert(!!_zonesBackup.value, 'revertCurrentZone: _zonesBackup should not be null');
        console.assert(!!_manualZoneNamesBackup.value, 'revertCurrentZone: _manualZoneNamesBackup should not be null');

        zones.value = cloneDeep(_zonesBackup.value);
        _manualZoneNames.value = cloneDeep(_manualZoneNamesBackup.value);
    }

    const addZones = (newZones: IDrawZone[]) => {
        if (!zones.value) {
            zones.value = [];
        }
        zones.value = zones.value.concat(newZones);
        KlDrawZoneMapUtils.updateZoneNames(zones.value, _maprequestReference.value, _manualZoneNames.value);
    }

    const backupZones = () => {
        _zonesBackup.value = cloneDeep(zones.value);
        _manualZoneNamesBackup.value = cloneDeep(_manualZoneNames.value);
    }

    const updateManualZoneName = (zoneId: number, name: string) => {
        _manualZoneNames.value[zoneId] = name;
    }

    const updateCurrentZone = (feature: Feature, price: number): void => {

        console.assert(!!currentZone.value, 'updateCurrentZone requires a current zone');

        // const currentFeature: Feature = _featureContext.findFeature(currentZone.value.id);
        // KlDrawZoneMapUtils.removeDuplicateCoordinates(currentFeature, props.allowMultiPolygons);
        KlDrawZoneMapUtils.updateDrawZone(currentZone.value, feature);
        KlDrawZoneMapUtils.updateZoneNames(zones.value, _maprequestReference.value, _manualZoneNames.value);
        currentZone.value.price = price; // _getZonePrice(currentZone.value.area); // TODO: move to utils?

        // const valid = await _validateZoneWithLoading(currentZone.value);
        // currentZoneError.value = first(currentZone.value.errorMessages);

        // when we have inter-zone constraints..
        // const valid = _allZonesValid();

        //_emitResult();

        //return valid;
    }

    const updateZoneName = (newName: string): boolean => {
        if (!validateZoneName(newName)) {
            return false;
        }
        if (currentZone.value.name !== newName) {
            currentZone.value.name = newName;
            _manualZoneNames.value[currentZone.value.id] = newName;
            KlDrawZoneMapUtils.updateZoneNames(zones.value, _maprequestReference.value, _manualZoneNames.value);
        }
        //currentZoneName.value = null;
        //editZoneName.value = false;

        return true;
    }

    const validateZoneName = (newName: string): boolean => {
        return size(newName) <= 100;
    }

    return {
        init,

        zones,
        currentZone,

        updateMaprequestReference,

        clearAll,
        removeZone,
        setCurrentZone,
        revertCurrentZone,
        addZones,
        backupZones,
        updateCurrentZone,

        updateZoneName,
        validateZoneName,
        updateManualZoneName, // bah
    }
}
